import React, { useContext, useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import AppRoutes from './Routes/AppRoutes';
import useSocketAPI from './hooks/network/useSocketAPI';
import { AppContext } from './context/AppContext';
import { isAuthenticated } from './helper/authHelper';

function App() {
  const { loadApp } = useContext(AppContext);

  if (isAuthenticated()) {
    useSocketAPI();
  }

  useEffect(() => {
    if (isAuthenticated()) {
      loadApp?.();
    }
  }, []);

  return (
    <div className='App'>
      <ToastContainer />
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </div>
  );
}

export default App;
